import { routes } from '~/routes';
import { useRequireSignUpStep } from '../shared/useRequireSignUpStep';
import { SignUpStepWrapper } from '../shared/SignUpStepWrapper';
import { YourInfoForm } from './YourInfoForm';

export const YourInfoPage = () => {
  useRequireSignUpStep(routes.signUpRedesign.yourInfo);

  return (
    <SignUpStepWrapper
      step={1}
      backTo={routes.signUpRedesign.signUp}
      title="Let’s Get Started"
      subtitle="Tell us about you to discover how many professionals are available near your office."
    >
      <YourInfoForm />
    </SignUpStepWrapper>
  );
};
